import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import {
  faTemperatureEmpty,
  faDroplet,
  faBuilding,
  faThermometer,
  faLocationCrosshairs,
  faWarehouse,
  faBell,
  faTemperature0,
  faExclamation,
  faSun,
  faMapMarkedAlt,
  faB,
  faClock,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { SettingsService } from "../../../../services/settings.service";
import { GET_ALL_MSD_WAREHOUSE } from "../../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import { GraphqlService } from "../../../../services/graphql.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store";
import { Warehouse } from "../../../../store/entities/warehouse-management/warehouse/warehouse.model";
import { ActivatedRoute } from "@angular/router";
import { StoreItemActions } from "../../../../store/entities/store-item/store-item.actions";
import { selectStoreItems } from "../../../../store/entities/store-item/store-item.selectors";
import { StoreItemEntity } from "../../../../store/entities/store-item/store-item.model";
import { GET_WAREHOUSE_LATEST_READINGS } from "../../../../store/entities/shared/temp-humidity-graph/temp-humidity-graph.graphql";
import { faTemperature4 } from "@fortawesome/free-solid-svg-icons/faTemperature4";
import { GET_ALERT_DASHBOARD_DATA_QUERY } from "../../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql";
import { GET_ALL_SENSORS } from "../../../../store/entities/warehouse-management/device/device.graphql";
import { Observable } from "rxjs";
import {
  GET_WAREHOUSE_DASHBOARD_DATA,
  GET_WAREHOUSE_FORECAST_DATA,
  GET_WAREHOUSE_REALTIME_READINGS,
} from "../../../../store/entities/warehouse-management/item-dashboard/item-dashboard.graphql";
import { environment } from "../../../../../environments/environment";
import { LayoutService } from "../../../../shared/components/app-layout/shared-layout/layout.service";
import { StorageService } from "../../../../services/storage.service";
import { SensorStatusModalComponent } from "./sensor-status-modal/sensor-status-modal.component";
import { AlertsModalComponent } from "./alerts-modal/alerts-modal.component";
import { WarehouseAddComponent } from "../warehouse-add/warehouse-add.component";
import { WarehouseZoneAddComponent } from "./warehouse-zone-list/warehouse-zone-add/warehouse-zone-add.component";
import { WarehouseSensorAddComponent } from "./warehouse-sensor-list/warehouse-sensor-add/warehouse-sensor-add.component";
import { IconProp } from "@fortawesome/angular-fontawesome/types";
import { TempStabilityModalComponent } from "../../warehouse-management-dashboard/temp-stability-modal/temp-stability-modal.component";
import { HumidityStabilityModalComponent } from "../../warehouse-management-dashboard/humidity-stability-modal/humidity-stability-modal.component";
import gql from "graphql-tag";
import { CoverageModalComponent } from "../../warehouse-management-dashboard/coverage-modal/coverage-modal.component";
interface Stability {
  warehouse_name: string;
  temp_stability: number;
  humidity_stability: number;
}

const GET_WAREHOUSE_COVERAGE = gql`
  query GetWarehouseCoverageStatus($filtering: WarehouseCoverageFilteringObject) {
    getWarehouseCoverageStatus(filtering: $filtering) {
      data {
        dashboardData
      }
    }
  }
`;

const GET_WAREHOUSE_READING_STABILITY = gql`
  query GetWarehouseReadingStability {
    getWarehouseReadingStability {
      response {
        id
        status
        code
        message
      }
      data {
        dashboardData
      }
    }
  }
`;

const GET_COLDROOM_READING_STABILITY = gql`
  query GetColdRoomReadingStability($filtering: StabilityFilteringObject) {
    getColdRoomReadingStability(filtering: $filtering) {
      data {
        dashboardData
      }
      response {
        message
        status
        id
        code
      }
    }
  }
`;
@Component({
  selector: "app-warehouse-view",
  templateUrl: "./warehouse-view.component.html",
  styleUrls: ["./warehouse-view.component.scss"],
})
export class WarehouseViewComponent implements OnInit, OnDestroy {
  private refreshInterval: any;
  private settingService: SettingsService = inject(SettingsService);
  private apollo: GraphqlService = inject(GraphqlService);
  private store: Store<AppState> = inject(Store<AppState>);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private layoutService: LayoutService = inject(LayoutService);
  private storageService: StorageService = inject(StorageService);
  private settingsService: SettingsService = inject(SettingsService);
  protected readonly faCircleExclamation = faCircleExclamation;


  protected readonly faBuilding = faBuilding;
  protected readonly faThermometer = faThermometer;
  protected readonly faLocationCrosshairs = faLocationCrosshairs;
  protected readonly faWarehouse = faWarehouse;
  protected readonly faBell = faBell;
  protected readonly faTemperature0 = faTemperature0;
  protected readonly faTemperature4 = faTemperature4;
  protected readonly faDroplet = faDroplet;
  protected readonly faTemperatureEmpty = faTemperatureEmpty;
  protected readonly faExclamation = faExclamation;
  protected readonly faSun = faSun;
  protected readonly faMapMarkedAlt = faMapMarkedAlt;

  userDetails = this.storageService.get("userProfileDetails");
  userWarehouse = this.userDetails?.warehouse_unique_id;
  tableColumns: object;
  searchInput: string = "";
  // stabilityReadings: Stability[] = [];
  stabilityResponse: any = null;
  stabilityReadings: any[] = [];
  coldRoomStabilityResponse: any = null;
  coldRoomStabilityReadings: any[] = [];

  title;
  loadingData: boolean = true;
  showChart: boolean = false;
  lineChartsTabs: { name: string; slug: "lineChartsTemp" | "lineChartsHum" }[] =
    [
      { name: "Temperature", slug: "lineChartsTemp" },
      { name: "Humidity", slug: "lineChartsHum" },
    ];
  listTabs: {
    name: string;
    slug: "zonesList" | "sensorsList";
  }[] = [
    { name: "Sensors List", slug: "sensorsList" },
    { name: "Zones List", slug: "zonesList" },
  ];
  activeSlugLineCharts: "lineChartsTemp" | "lineChartsHum" = "lineChartsTemp";
  activeSlugzonesList: "zonesList" | "sensorsList" = "sensorsList";
  xAxis: string[] = [];
  currentTime: string;
  sixHoursPast: string;
  warehouse: Warehouse;
  dashboardData: any;
  dashboardRealtimeSummary: any;
  warehouseForecastData: any;
  tempLineChartsData: any[] = [];
  humLineChartsData: any[] = [];
  items;
  dashboardCardData: any;
  warehouses$: Observable<Warehouse[]>;
  refreshTable: boolean = false;
  warehouseId;
  dataPulledAt: string;
  fetchStatus: "fixed" | "live" = "live";
  zoneSearchTerm: string = "";
  sensorSearchTerm: string = "";
  zones: any[] = [];
  filteredZones: any[] = [];

  sensors: any[] = [];
  filteredSensors: any[] = [];
  faChartArea: IconProp;
  coverageData: any;
  coverageLoading = false;

  async ngOnInit() {
    this.fetchAllData();
    this.fetchStability();
    this.fetchColdRoomStability();
    this.route.queryParams.subscribe((param) => {
      this.warehouseId = param["id"];
      this.fetchAllData();
      this.refreshTable = !this.refreshTable;
    });
    this.fetchRealtime(this.fetchStatus);

    this.filteredZones = [...this.items]; // if zones
    this.filteredSensors = [...this.items];
  }
  fetchRealtime(status) {
    switch (status) {
      case "fixed":
        break;
      case "live":
        const now = new Date();
        const then = new Date();
        then.setHours(now.getHours() - 6);
        this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
        this.sixHoursPast =
          this.settingService.formatDateForDateTimeLocal(then);
        this.refreshInterval = setInterval(() => {
          this.loadRealtimeAvgData();
          this.fetchGraphData();
        }, 15000);
    }
  }
  setFetchStatus() {
    this.fetchStatus = "live";
    this.fetchRealtime(this.fetchStatus);
    this.fetchGraphData();
  }
async fetchStability() {
  try {

    const warehouseId = this.route.snapshot.queryParams["id"];

    const result: any = await this.apollo.query({
      query: GET_WAREHOUSE_READING_STABILITY,
      variables: {
     
        filtering: {
          warehouseUniqueId: warehouseId
        }
      },
    });

    const responseBlock = result?.data?.getWarehouseReadingStability;

    if (responseBlock?.response?.status) {
      const rawDashboardData = responseBlock?.data?.dashboardData;

      const parsed =
        typeof rawDashboardData === "string"
          ? JSON.parse(rawDashboardData)
          : rawDashboardData;

      this.stabilityResponse = parsed;
      this.stabilityReadings = parsed?.warehouses ?? [];
    }
  } catch (error) {
    console.error("Error fetching stability:", error);
  }
}

async fetchColdRoomStability() {
  try {
    const warehouseId = this.route.snapshot.queryParams["id"];
    const now = new Date();
    const sixHoursAgo = new Date();
    sixHoursAgo.setHours(now.getHours() - 6);

    const result: any = await this.apollo.query({
      query: GET_COLDROOM_READING_STABILITY,
      variables: {
        filtering: {
          dateFrom: this.settingService.formatDateForDateTimeLocal(sixHoursAgo),
          dateTo: this.settingService.formatDateForDateTimeLocal(now),
          warehouseUniqueId: warehouseId
        }
      },
    });

    const responseBlock = result?.data?.getColdRoomReadingStability;

    if (responseBlock?.response?.status) {
      const rawDashboardData = responseBlock?.data?.dashboardData;

      const parsed =
        typeof rawDashboardData === "string"
          ? JSON.parse(rawDashboardData)
          : rawDashboardData;

      this.coldRoomStabilityResponse = parsed;
      this.coldRoomStabilityReadings = Array.isArray(parsed)
        ? parsed
        : (parsed?.warehouses ?? parsed?.coldrooms ?? []);
    }
  } catch (error) {
    console.error("Error fetching cold room stability:", error);
  }
}

  async fetchAllData() {
    await this.getItems();
    this.setCurrentTime();
    this.setSixHoursPastTime();
    this.fetchGraphData();
    this.loadDashboardData();
    this.loadRealtimeAvgData();
    this.loadWarehouseForecastData();
    this.fetchCoverageData();
    setTimeout(() => {
      this.showChart = true;
    }, 1000);
    this.fetchAllWarehouses();
  }
cardClicked(
  type: "zone" | "alert" | "temperature" | "humidity" | "sensor" | "coverage" | "coldroom-temperature" | "coldroom-humidity",
  duration: "TODAY" | "LAST_7_DAYS" | "THIS_MONTH" = null
) {
  const warehouseId = this.route.snapshot.queryParams["id"]; // declare once

  switch (type) {
    case "zone":
      this.activeSlugzonesList = "zonesList";
      document.getElementById("tables").scrollIntoView({ behavior: "smooth" });
      break;

    case "alert":
      this.settingsService.openDialogModal({
        component: AlertsModalComponent,
        width: "500",
        data: { duration, warehouseUniqueId: warehouseId },
      });
      break;

    case "sensor":
      this.settingsService.openDialogModal({ component: SensorStatusModalComponent });
      break;

    case "temperature":
      console.log("Opening Temperature modal with data:", this.stabilityResponse, warehouseId);
      this.settingsService.openDialogModal({
        component: TempStabilityModalComponent,
        data: { stability: this.stabilityResponse, ...(warehouseId && { warehouseUniqueId: warehouseId }) },
      });
      break;

    case "humidity":
      console.log("Opening Humidity modal with data:", this.stabilityResponse, warehouseId);
      this.settingsService.openDialogModal({
        component: HumidityStabilityModalComponent,
        data: { stability: this.stabilityResponse, ...(warehouseId && { warehouseUniqueId: warehouseId }) },
      });
      break;

    case "coldroom-temperature":
      this.settingsService.openDialogModal({
        component: TempStabilityModalComponent,
        data: { stability: this.coldRoomStabilityResponse, ...(warehouseId && { warehouseUniqueId: warehouseId }) },
      });
      break;

    case "coldroom-humidity":
      this.settingsService.openDialogModal({
        component: HumidityStabilityModalComponent,
        data: { stability: this.coldRoomStabilityResponse, ...(warehouseId && { warehouseUniqueId: warehouseId }) },
      });
      break;
     case "coverage":
 
      this.settingsService.openDialogModal({
        component: CoverageModalComponent,
        width: "700px",
        data: {
          coverage: this.coverageData,
          warehouseUniqueId: warehouseId
        }
      });
      break;

      
  }
}

  changeWarehouse(event: Event) {
    const warehouseId = (event.target as HTMLSelectElement).value;
    this.layoutService.openPanel({ action: "view", id: warehouseId });
  }
  fetchAllWarehouses() {
    const filters = this.userWarehouse
      ? { pageNumber: 1, uniqueId: this.userWarehouse }
      : { pageNumber: 1 };
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.warehouse,
        filtering: filters,
        query: GET_ALL_MSD_WAREHOUSE,
      })
    );
    this.warehouses$ = this.store.select(
      selectStoreItems(StoreItemEntity.warehouse)
    );
  }
  async getItems() {
    const result: any = await this.apollo.query({
      query: GET_ALL_SENSORS,
      variables: {
        filtering: {
          pageNumber: 1,
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });

    const { data, response } = result.data.getAllSensors;

    if (response.status) {
      this.items = data?.map((item) => {
        return {
          image: item?.posPicture
            ? environment.MEDIA_SERVER_URL + item?.posPicture
            : "assets/images/placeholder.webp",
          title: item?.sensorName,
        };
      });
    }
  }
  async fetchAlertDetails(): Promise<void> {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        filtering: {
          warehouse: this.route.snapshot.queryParams["id"],
          pageNumber: 1,
        },
        entity: StoreItemEntity.alertDashboard,
        query: GET_ALERT_DASHBOARD_DATA_QUERY,
      })
    );
    this.store
      .select(selectStoreItems(StoreItemEntity.alertDashboard))
      .subscribe((res) => {
        this.warehouse = res[0];
      });
  }

  onAdd(item: any = null) {
    if (this.activeSlugzonesList === "zonesList") {
      this.settingsService.openDialogModal({
        component: WarehouseZoneAddComponent,
        data: {
          zone: item,
        },
      });
    } else if (this.activeSlugzonesList === "sensorsList") {
      this.settingsService.openDialogModal({
        component: WarehouseSensorAddComponent,
        data: {
          sensor: item,
        },
      });
    }
  }

  async loadDashboardData() {
    // this.loadingData = true

    const query = GET_WAREHOUSE_DASHBOARD_DATA;
    const response: any = await this.apollo.query({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });

    const dashboardDataCardData =
      response?.data?.getWarehouseDashboardData?.data?.dashboardData;
    if (dashboardDataCardData) {
      try {
        this.dashboardCardData = JSON.parse(dashboardDataCardData);
        this.updateGraphData();
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }
    // this.loadingData = false
  }

  async fetchCoverageData() {
    this.coverageLoading = true;
    try {
      const response: any = await this.apollo.query({
        query: GET_WAREHOUSE_COVERAGE,
        variables: {
          filtering: {
            warehouseUniqueId: this.route.snapshot.queryParams["id"],
          },
        },
      });
      const rawData = response?.data?.getWarehouseCoverageStatus?.data?.dashboardData;
      const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
      if (parsed?.coverage_ratio) {
        parsed.numeric_ratio = parseFloat(parsed.coverage_ratio.replace('%', ''));
      }
      this.coverageData = parsed;
    } catch (error) {
      console.error("Error fetching coverage data:", error);
    }
    this.coverageLoading = false;
  }

  async loadRealtimeAvgData() {
    // this.loadingData = false

    const query = GET_WAREHOUSE_REALTIME_READINGS;
    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });

    const dashboardRealtimeAvgData =
      response?.data?.getWarehouseRealTimeReadings?.data?.dashboardData;
    if (dashboardRealtimeAvgData) {
      try {
        this.dashboardRealtimeSummary = JSON.parse(dashboardRealtimeAvgData);
        const options: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: "short", // Short month name (e.g., Jan, Feb, etc.)
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour clock (e.g., 04:34 PM)
        };
        const date = new Date();
        this.dataPulledAt = new Intl.DateTimeFormat("en-GB", options).format(
          date
        );
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }
    // this.loadingData = false
  }

  async loadWarehouseForecastData() {
    // this.loadingData = false;

    const query = GET_WAREHOUSE_FORECAST_DATA;
    const response: any = await this.apollo.query({
      query,
      variables: {
        filtering: {
          warehouse: this.route.snapshot.queryParams["id"],
        },
      },
    });

    const getWarehouseForecastData =
      response?.data?.getWarehouseForecastData?.data?.dashboardData;

    if (getWarehouseForecastData) {
      try {
        const sanitizedData = getWarehouseForecastData.replace(/NaN/g, "null");

        this.warehouseForecastData = JSON.parse(sanitizedData);
      } catch (error) {
        console.error("Error parsing dashboardCardData:", error);
      }
    } else {
      console.error("dashboardCardData is not available");
    }

    // this.loadingData = false;
  }
  async fetchGraphData(): Promise<void> {
    const query =
      this.activeSlugLineCharts === "lineChartsTemp"
        ? GET_WAREHOUSE_LATEST_READINGS
        : GET_WAREHOUSE_LATEST_READINGS;

    const response: any = await this.apollo.queryNoLoader({
      query,
      variables: {
        filtering: {
          pageNumber: 1,
          warehouse: this.route.snapshot.queryParams["id"],
          dateFrom: this.sixHoursPast,
          dateTo: this.currentTime,
        },
      },
    });

    const dashboardDataString =
      response?.data?.getWarehouseLatestReadings?.data?.dashboardData;
    if (dashboardDataString) {
      try {
        this.dashboardData = JSON.parse(dashboardDataString);
        await this.updateGraphData();
        this.loadingData = false;
      } catch (error) {
        this.loadingData = false;
        console.error("Error parsing dashboardData:", error);
      }
    } else {
      this.loadingData = false;
      console.error("dashboardData is not available");
    }
  }

  async onTimeChange() {
    this.fetchStatus = "fixed";
    await this.fetchGraphData();
  }

  async onTabChange(slug: "lineChartsTemp" | "lineChartsHum") {
    this.loadingData = true;
    this.activeSlugLineCharts = slug;
    this.showChart = false;
    await this.fetchGraphData();
    this.showChart = true;
  }

  async onListTabChange(slug: "zonesList" | "sensorsList") {
    this.activeSlugzonesList = slug;
    this.searchInput = ""; // reset search when switching tabs
    if (slug === "zonesList") {
      this.filteredZones = this.items;
    } else {
      this.filteredSensors = this.items;
    }
  }

  onSearchInputChange() {
    if (this.activeSlugzonesList === "zonesList") {
      this.filteredZones = this.items.filter((zone) =>
        zone.name.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    } else {
      this.filteredSensors = this.items.filter((sensor) =>
        sensor.title.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    }
  }

  onSearchIconClick() {
    // Just trigger the same search function when the icon is clicked
    this.onSearchInputChange();
  }

  updateGraphData() {
    const readings = this.dashboardData?.READINGS;
    if (readings && readings.length > 0) {
      const reversedReadings = [...readings].reverse();

      this.xAxis = reversedReadings.map((reading) =>
        new Date(reading.TIMESTAMP).toLocaleTimeString()
      );

      if (this.activeSlugLineCharts === "lineChartsTemp") {
        this.tempLineChartsData = [
          {
            name: "Temperature",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.TEMPERATURE).toFixed(2)
            ),
            color: "#23AFF1",
          },
        ];
      } else {
        this.humLineChartsData = [
          {
            name: "Humidity",
            data: reversedReadings.map((reading) =>
              parseFloat(reading.HUMIDITY).toFixed(2)
            ),
            color: "#025590",
          },
        ];
      }
    }
  }
  setCurrentTime() {
    const now = new Date();
    this.currentTime = this.settingService.formatDateForDateTimeLocal(now);
  }
  setSixHoursPastTime() {
    const now = new Date();
    now.setHours(now.getHours() - 6);
    this.sixHoursPast = this.settingService.formatDateForDateTimeLocal(now);
  }
  getWeatherIcons(
    temperature: number,
    humidity: number
  ): { tempIcon: string; humidityIcon: string } {
    let tempIcon: string;
    let humidityIcon: string;

    // Set temperature icon
    if (temperature > 30) {
      tempIcon = "assets/images/temperature-high.svg";
    } else if (temperature > 20) {
      tempIcon = "assets/images/temperature-medium.svg";
    } else if (temperature > 10) {
      tempIcon = "assets/images/temperature-low.svg";
    } else {
      tempIcon = "assets/images/cloud-snowfall.svg";
    }

    // Set humidity icon
    if (humidity > 80) {
      humidityIcon = "assets/images/humidity-low.svg";
    } else if (humidity > 60) {
      humidityIcon = "assets/images/humidity-medium.svg";
    } else {
      humidityIcon = "assets/images/humidity-high.svg";
    }

    return { tempIcon, humidityIcon };
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  protected readonly faClock = faClock;
}
